import { Block as e } from "../../components/FocusBlock.es.js";
import { FactboxModified as t } from "./FactboxModified.es.js";
import { FactboxHeaderItem as n } from "./FactboxHeaderItem.es.js";
import { FilePen as r, X as i } from "lucide-react";
import { jsx as a, jsxs as o } from "react/jsx-runtime";
import { Transforms as s } from "slate";
// lib/Factbox/components/Factbox.tsx
var c = ({ children: c, element: l, options: u, editor: d }) => {
	let f = l?.properties?.created ?? l?.properties?.original_updated ?? "", p = l?.properties?.modified ?? "", m = l?.properties?.original_id, h = !!m && m !== l?.id, g = u?.removable ?? !1, _ = u?.locale, { headerTitle: v, createdLabel: y, lastModifiedLabel: b, footerTitle: x } = u, S = x ?? "Changes in the factbox text only affects this article";
	return /* @__PURE__ */ a(e, {
		editor: d,
		element: l,
		children: /* @__PURE__ */ o("div", {
			className: "group border-2 rounded border-slate-200",
			children: [
				/* @__PURE__ */ o("div", {
					contentEditable: !1,
					draggable: !0,
					className: "flex justify-start items-center m-1 p-2 bg-slate-100 dark:bg-slate-700 border-b-2 border-slate-200 ps-0.5 pb-0.5 pt-px cursor-default",
					onMouseDown: (e) => {
						e.stopPropagation();
					},
					children: [
						u?.onEditOriginal && typeof u.onEditOriginal == "function" && h ? /* @__PURE__ */ a(n, {
							title: v ?? "Edit the original factbox",
							onMouseDown: (e) => {
								e.preventDefault(), e.stopPropagation(), u.onEditOriginal(m);
							},
							icon: { icon: r }
						}) : null,
						/* @__PURE__ */ o("div", {
							className: "flex flex-col grow",
							children: [f && /* @__PURE__ */ a(t, {
								modified: f,
								modifiedLabel: y ?? "Created",
								locale: _,
								absolute: !0
							}), p && /* @__PURE__ */ a(t, {
								modified: p,
								modifiedLabel: b ?? "Last modified",
								locale: _
							})]
						}),
						g && /* @__PURE__ */ a("div", {
							className: "flex grow-0 items-center justify-end",
							children: /* @__PURE__ */ a(n, {
								className: "opacity-60 hover:opacity-100",
								icon: { icon: i },
								onMouseDown: (e) => {
									e.preventDefault(), e.stopPropagation();
									let t = d.children.findIndex((e) => e.id === l.id);
									t > -1 && s.removeNodes(d, { at: [t] });
								}
							})
						})
					]
				}),
				/* @__PURE__ */ a("div", {
					className: "px-6 pt-1 pb-2",
					children: c
				}),
				/* @__PURE__ */ a("div", {
					contentEditable: !1,
					className: "flex items-center gap-2 text-xs text-red-800 m-1 p-2 dark:text-red-500 bg-slate-100 dark:bg-slate-700 rounded-sm px-2 py-1",
					children: S
				})
			]
		})
	});
};
export { c as Factbox };
